import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Store
import { store, persistor } from './redux';

// Theme
import { ThemeProvider } from './theme/ThemeProvider';

// Components
import ThemeInitializer from './components/ThemeInitializer';
import AuthInitializer from './components/AuthInitializer';

// Routes
import AppRoutes from './routes';
import NavigationSetup from './routes/NavigationSetup';



function App() {
  console.log('🚀 App: Component starting...');
  
  return (
    <Provider store={store}>
      <PersistGate loading={<div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontSize: '20px'
      }}>Loading Redux data...</div>} persistor={persistor}>
        <ThemeProvider>
          <ThemeInitializer>
            <Router>
              <AuthInitializer>
                <NavigationSetup />
                <AppRoutes />
              </AuthInitializer>
            </Router>
          </ThemeInitializer>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

export default App; 